'use client';

import { useSearchParams } from 'next/navigation';
import { Heading } from 'ui';
import { Card } from '~/components/Card';

export default function JourneyGuideHeader() {
  const searchParams = useSearchParams();
  const summary = searchParams?.get('summary');

  return (
    <Card spaceHorizontal="--by-space-400" spaceVertical="--by-space-300">
      <Heading as="h2" variant="h6">
        {summary ? 'Journey Summary' : 'Journey Guide'}
      </Heading>
    </Card>
  );
}
